import CryptoJS from "crypto-js";
import { replace, useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import OtpShared from "../../../../_shared/OtpScreen/otpPage";
import SubFooter from "../../../../_shared/subFooter/subFooter";
import * as globalUtils from "../../../../helpers/utils";
import { renewalActions } from "../../../../redux/actions";
import {
  updateYob,
  updateCurrentPolicy,
  updateDefaultValues,
  updateQuotationDetails,
  updateUid,
  setAuthentication,
} from "../../../../redux/actions/renewal";
import * as renewalService from "../../../../services/renewal-service";
import Popup from "../../components/Popup/Popup";
import LoginWrapper from "./login.style";
import { submitCRMCampaignApi } from "../../../../services/crmApi";
import { toGregorian } from "hijri-converter";

const LoginNew = ({ i18n }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [failedOTPCount, setFailedOTPCount] = useState(0);
  const [lob, setLOB] = useState("NormalRenewal");
  const [userMobile, setUserMobile] = useState("");
  const [userDetails, setUserDetails] = useState({});
  const [qoutationDetailsResponse, setQoutationDetailsResponse] = useState();
  const [policyData, setPolicyData] = useState();
  const [dateOptions, setDateOptions] = useState(
    globalUtils.getGregYearOfBirthList()
  );
  const [dateMonthOptions, setDateMonthOptions] = useState(
    globalUtils.months_hijri_ar
  );
  const [isHijri, setIsHijri] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [ctaVisible, setctaVisible] = useState(false);
  const [ctaText, setctaText] = useState("");
  const [ctaLink, setctaLink] = useState("");
  const [autoRedirect, setAutoRedirect] = useState(false);
  const toast = useRef(null);
  const dispatch = useDispatch();
  const currentStepIndex = useSelector((state) => state.renewal.otpIndex);
  const yob = useSelector((state) => state.renewal.yob);
  // const uid = useSelector((state) => state.renewal.uid);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const encId = params.get("id");
  const encYob = params.get("yob");

  const isLoggedIn = useSelector((state) => state.renewal.isLoggedIn);
  const uid = searchParams.get("uid");
  let lang = searchParams.get("lang") || "en";
  let direction = "ltr";

  const getUserDetails = async () => {
    const userDetails = await renewalService.getUserDetails({
      UIFkey: uid,
    });

    if (userDetails.data.resultCode != "S") {
      throw new Error(userDetails.data.resultMessage);
    }

    setUserDetails({ ...userDetails.data });
    setShowOtp(true);

    formik.setFieldValue("idNumber", "**********");
    formik.setFieldValue("yob", "****");
  };

  useEffect(() => {
    if (uid && !isLoggedIn) {
      localStorage.setItem("renewalUid", uid);
      setLoading(true);
      setLOB("Renewal");
      getUserDetails();
    }
  }, []);

  useEffect(() => {
    if (i18n.language === "ar") {
      setDateMonthOptions(globalUtils.months_hijri_ar);
    } else {
      setDateMonthOptions(globalUtils.months_hijri_en);
    }
  }, [i18n.language]);

  const retriveData = async (otp) => {
    try {
      setLoading(true);

      const renewalListResponse = await renewalService.getRenewalList({
        languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
        otp,
        idNumber: userDetails.idNo,
        yob: userDetails.yob,
      });

      if (!renewalListResponse.data.getRenewalListResponse) {
        setFailedOTPCount((count) => (count += 1));
        // throw new Error(renewalListResponse.data.resultMessage);
        if (renewalListResponse.data.errorCode === "4") {
          setLoading(false);
          setAutoRedirect(true);
          setctaText("renewal.errors.case4");
          setctaLink(
            `https://tawuniya.com/product/#/motor?id=${getHashing(
              formik.values.idNumber
            )}
                        &yob=${getHashing(formik.values.yob)}
                      `
          );
          setctaVisible(true);
          return;
        } else {
          throw new Error(
            renewalListResponse.data.resultMessage
          );
        }
      }

      if (renewalListResponse?.data?.getRenewalListResponse?.resultCode === "S") {
        setShowOtp(false);
        const { authToken, requestId, jwt } =
          renewalListResponse.data.getRenewalListResponse;
        dispatch(setAuthentication({ authToken, requestId, jwt }));
      }
      const policyData =
        renewalListResponse.data.getRenewalListResponse["policyList"][
          "policyListArray"
        ][0];

      const quotationDetailsResponse = await renewalService.getQuotationDetails(
        {
          productCode: policyData.productCode,
          idNumber: userDetails.idNo,
          quotationNumber: policyData.quotationNumber,
          languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
          tmx: policyData.quotationNumber,
        }
      );

      if (quotationDetailsResponse.data.resultCode === "S") {
        submitCRMCampaignApi(policyData.quotationNumber, "MMR");
      } else {
        throw new Error(quotationDetailsResponse.data.resultMessage);
      }

      const {
        makeCode,
        modelCode,
        yearOfManufacture,
        chassisNumber,
        plateNumber,
        vehicleValue,
      } = quotationDetailsResponse.data.vehicleDetails.vehicleDetailsArray[0];

      const defaultValues = await renewalService.getDefaultValues({
        yearOfManufacture: yearOfManufacture,
        modelCode: modelCode,
        makeCode: makeCode,
        chassisNumber: chassisNumber,
        languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
      });
      if (defaultValues.data.resultCode !== "S") {
        throw new Error(defaultValues.data.resultMessage);
      }
      const myPolicyData =
        renewalListResponse.data.getRenewalListResponse.policyList
          .policyListArray[0];

      if (vehicleValue == 0) {
        quotationDetailsResponse.data.vehicleDetails.vehicleDetailsArray[0].vehicleValue =
          defaultValues.data.vehicleValue.avg;
      }

      dispatch(updateCurrentPolicy(myPolicyData));
      dispatch(updateQuotationDetails(quotationDetailsResponse.data));
      dispatch(updateDefaultValues(defaultValues.data));
      dispatch(updateUid(true));
      setLoading(false);
      if (plateNumber.startsWith("T") || plateNumber.startsWith("t")) {
        navigate("/renewal/KycFail", { replace: true });
        return;
      }
      navigate("/renewal/vehicle-driver-info", { replace: true });
    } catch (err) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: err.message,
        life: 10000,
      });
    }
  };

  const handleNormalRenewalJr = (otp) => {
    renewalService
      .getRenewalList({
        idNumber: formik.values.idNumber,
        yob: formik.values.yob,
        otp,
        isValidCaptcha: true,
        languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
      })
      .then(async (renewalListResponse) => {
        setLoading(false);
        try {

          if (
            renewalListResponse?.data?.getRenewalListResponse?.resultCode !== "S" || 
            renewalListResponse?.data?.resultCode !== "S"
          ) {
            setFailedOTPCount((count) => (count += 1));
            const errorCode = renewalListResponse?.data?.getRenewalListResponse?.errorCode ||
            renewalListResponse?.data?.errorCode
            switch (errorCode) {
              case "2":
                setctaText("renewal.errors.case2");
                setctaLink("");
                setctaVisible(true);
                return;
              case "3":
                setctaText("renewal.errors.case3");
                setctaLink("https://tawuniya.com/products/#/renewal");
                setctaVisible(true);
                return;
              case "4":
                setAutoRedirect(true);
                setctaText("renewal.errors.case4");
                setctaLink(
                  `https://tawuniya.com/product/#/motor?id=${getHashing(
                    formik.values.idNumber
                  )}
                  &yob=${getHashing(formik.values.yob)}
                `
                );
                setctaVisible(true);
                return;
              case "5":
                setctaText("renewal.errors.case5");
                setctaLink(
                  `https://tawuniya.com/product/#/motor?id=${getHashing(
                    formik.values.idNumber
                  )}
                  &yob=${getHashing(formik.values.yob)}
                `
                );
                setctaVisible(true);
                return;
              default:
                showError(
                  renewalListResponse.data.getRenewalListResponse.resultMessage
                );
            }
            // window.grecaptcha.reset();
            setIsSubmitted(true);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "error_displayed",
              error_location: "Motor Insurance Renew",
              funnel_step: "step_1",
              error_messages:
                renewalListResponse.data.getRenewalListResponse.resultMessage,
            });
            return;
          }


          
          if (
            renewalListResponse.data.getRenewalListResponse.resultCode === "S"
          ) {
            setShowOtp(false);
            const { authToken, requestId, jwt } =
              renewalListResponse.data.getRenewalListResponse;
            dispatch(setAuthentication({ authToken, requestId, jwt }));
          }

          dispatch(updateYob(formik.values.yob));
          const policyData =
            renewalListResponse.data.getRenewalListResponse.policyList
              .policyListArray[0];
          setPolicyData(policyData);

          const qoutationDetailsResponse =
            await renewalService.getQuotationDetails({
              quotationNumber: policyData.quotationNumber,
              productCode: policyData.productCode,
              idNumber: formik.values.idNumber,
              languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
            });

          if (qoutationDetailsResponse.data.resultCode !== "S") {
            setLoading(false);
            showError(qoutationDetailsResponse.data.resultMessage);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "error_displayed",
              error_location: "Motor Insurance Renew",
              funnel_step: "step_2",
              error_messages: qoutationDetailsResponse.data.resultMessage,
            });
            // window.grecaptcha.reset();
            return;
          }

          submitCRMCampaignApi(policyData.quotationNumber, "MMR");

          //block the user with custom card
          const { plateNumber } =
            qoutationDetailsResponse.data.vehicleDetails.vehicleDetailsArray[0];
          if (plateNumber.startsWith("T") || plateNumber.startsWith("t")) {
            navigate("/renewal/KycFail", { replace: true });
            return;
          }

          setQoutationDetailsResponse(qoutationDetailsResponse);
          setUserMobile(
            qoutationDetailsResponse.data.customerDetails.policyHolder[0].mobile
          );
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "otp_landing",
            ecommerce: {
              funnel_step: "step_2",
              step_name: "motor_insurance_login_renew_otp_landing",
              items: [
                {
                  item_name: "Motor Insurance Login Renew",
                  item_category: "Motor Insurance",
                  item_class: "Individual",
                },
              ],
            },
          });

          const { makeCode, modelCode, yearOfManufacture, chassisNumber } =
            qoutationDetailsResponse.data.vehicleDetails.vehicleDetailsArray[0];
          renewalService
            .getDefaultValues({
              yearOfManufacture: yearOfManufacture,
              modelCode: modelCode,
              makeCode: makeCode,
              chassisNumber: chassisNumber,
              languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
            })
            .then((defaultValuesResponse) => {
              if (defaultValuesResponse.data.resultCode !== "S") {
                setLoading(false);
                showError(defaultValuesResponse.data.resultMessage);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "error_displayed",
                  error_location: "Motor Insurance Renew",
                  funnel_step: "step_3",
                  error_messages: defaultValuesResponse.data.resultMessage,
                });
                return;
              }

              dispatch(renewalActions.updateCurrentPolicy(policyData));
              console.log("d5", qoutationDetailsResponse.data);

              dispatch(
                renewalActions.updateQuotationDetails(
                  qoutationDetailsResponse.data
                )
              );

              dispatch(
                renewalActions.updateDefaultValues(defaultValuesResponse.data)
              );
              navigate("vehicle-driver-info", { replace: true });
            });
        } catch (err) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: "Motor Insurance Renew",
            funnel_step: "step_2",
            error_messages: err,
          });
          setLoading(false);
          showError("");
        }
      })
      .catch(function (error) {
        setLoading(false);
        showError(error.message);
        // window.grecaptcha.reset();
        setIsSubmitted(true);
      });
  };

  useEffect(() => {
    let lang = localStorage.getItem("i18nextLng") || params.get("lang");

    if (encId) {
      const id = CryptoJS?.AES.decrypt(
        encId.split(" ")?.join("+"),
        ""
      )?.toString(CryptoJS.enc.Utf8);
      if (id) {
        formik.setFieldValue("idNumber", id);
        // formik.setFieldValue("isValidCaptcha", !!id);
      }
    }
    if (lang) {
      if (lang == "en" || lang == "ar") {
        i18n.changeLanguage(lang);
      } else {
        const NewVal = CryptoJS?.AES.decrypt(
          lang?.split(" ")?.join("+"),
          ""
        )?.toString(CryptoJS.enc.Utf8);
        i18n.changeLanguage(NewVal);
      }
    }

    if (encYob) {
      const yob = CryptoJS.AES.decrypt(
        encYob?.split(" ")?.join("+"),
        ""
      )?.toString(CryptoJS.enc.Utf8);
      if (yob) {
        formik.setFieldValue("yob", yob);
      }
    }

    if (encId && encYob) {
      setTimeout(() => {
        formik.submitForm();
      }, 1500);
    }
  }, [location.search]);

  useEffect(() => {
    if (failedOTPCount == 3) {
      window.location.replace(`https://www.tawuniya.com/products/#/renewal`);
      setShowOtp(false);
      formik.values.idNumber("");
      formik.values.yob("");
    }
  }, [failedOTPCount]);

  const numbersTemplate = (option, props) => {
    if (option) {
      return <div className="numbers_drop">{option.label}</div>;
    }
    return <span className="my-auto">{props.placeholder}</span>;
  };

  const getHashing = (value) => {
    const idx = "";
    const message = CryptoJS.AES.encrypt(value, idx);
    return message.toString();
  };

  const formik = useFormik({
    initialValues: {
      idNumber: "",
      yob: "",
      mob: "",
      dob: "",
      isValidCaptcha: true,
    },
    validate: (data) => {
      let errors = {};
      if (data.idNumber) {
        if (data.idNumber.charAt(0) === "1") {
          setDateOptions([...globalUtils.getHijriYearOfBirthList()]);
        } else {
          setDateOptions([...globalUtils.getGregYearOfBirthList()]);
        }
      }
      if (!data.idNumber) {
        errors.idNumber = i18n.t("ERROR.REQUIRED");
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.idNumber)) {
        errors.idNumber = i18n.t("ERROR.MUST_10_DIGITS") + ' "1,2"';
      }
      if (!data.yob) {
        errors.yob = i18n.t("ERROR.REQUIRED");
      }
      if (isHijri) {
        if (!data.mob) {
          errors.mob = i18n.t("ERROR.REQUIRED");
        }
        if (!data.dob) {
          errors.dob = i18n.t("ERROR.REQUIRED");
        }
      }

      return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (data) => {
      setLOB("Renewal");
      setFailedOTPCount(0);
      setLoading(true);
      setShowOtp(true);
      if (isHijri) {
        const { gy } = toGregorian(+data.yob, +data.mob, +data.dob);
        setUserDetails({ yob: gy.toString(), idNo: data.idNumber });
        return;
      }
      setUserDetails({ yob: data.yob, idNo: data.idNumber });
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };
  const showError = (err) => {
    toast.current.clear();
    toast.current.show({ severity: "error", detail: err, life: 10000 });
  };

  useEffect(() => {
    dispatch(renewalActions.updateLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (!uid) {
      //
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          funnel_step: "step_0",
          step_name: "motor_insurance_login_renew_view_item",
          items: [
            {
              item_name: "Motor Insurance Login Renew",
              item_category: "Motor Insurance",
              item_class: "Individual",
              page_source: "internal_click",
            },
          ],
        },
      });
    }
  }, []);

  const onOTPVerify = (otp) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "otp_verified",
      ecommerce: {
        funnel_step: "step_3",
        step_name: "motor_insurance_login_renew_otp_verified",
        items: [
          {
            item_name: "Motor Insurance Login Renew",
            item_category: "Motor Insurance",
            item_class: "Individual",
          },
        ],
      },
    });

    if (lob === "Renewal") {
      retriveData(otp);
      return;
    }

    handleNormalRenewalJr(otp);
  };

  const handleCTAClick = (link) => {
    if (Boolean(link.length)) {
      setctaVisible(false);
      window.open(link);
    } else setctaVisible(false);
  };

  const isArabic = globalUtils.isArabic(i18n.language);

  const [taggingStep1, setTaggingStep1] = useState(false);

  useEffect(() => {
    if (
      (!!formik.values.idNumber || !!formik.values.yob) &&
      !taggingStep1 &&
      !uid
    ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          funnel_step: "step_1",
          step_name: "motor_insurance_login_renew_select_item",
          items: [
            {
              item_name: "Motor Insurance Login Renew",
              item_category: "Motor Insurance",
              item_class: "Individual",
              page_source: "internal_click",
            },
          ],
        },
      });
      setTaggingStep1(true);
    }

    if (formik.values.idNumber[0] === "1") {
      setIsHijri(true);
    } else {
      setIsHijri(false);
    }
  }, [formik.values.idNumber, formik.values.yob]);

  return (
    <LoginWrapper>
      <Toast ref={toast} className="mb-5" />
      <div className={"insured-wrapper"}>
        <div className={"container " + (isArabic ? "ar" : "")}>
          <div className="row">
            <div className="col-md-3 textContainer">
              <h3 className="retrieve">
                {i18n.t("Retrieve")}
                <span>{i18n.t("CarInformation")}</span>
              </h3>
            </div>
            <div className="col-md-9">
              <div
                className={
                  "add_wrapper " + (i18n.language === "ar" ? "ar" : "")
                }
              >
                <div className="form-wrapper">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className={`${isHijri ? "col-md-4" : "col-md-6"}`}>
                        <div className="field mb-4">
                          <label htmlFor="idNumber">
                            {i18n.t("ID_IQAMA")}
                            <span className="tawun_red"> *</span>
                          </label>
                          <InputText
                            id="idNumber"
                            name="idNumber"
                            value={formik.values.idNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur("idNumber")}
                            onKeyPress={(e) =>
                              globalUtils.isValidSaudiIDOrIQama(e)
                            }
                            maxLength={10}
                            disabled={false}
                            className={classNames({
                              "p-invalid": isFormFieldValid("idNumber"),
                            })}
                          />

                          {getFormErrorMessage("idNumber")}
                        </div>
                      </div>
                      <div className={`${isHijri ? "col-md-3" : "col-md-6"}`}>
                        <div className="field mb-3">
                          <label htmlFor="yearOfBirth">
                            {i18n.t("YEAR_OF_BIRTH")}{" "}
                            <span className="tawun_red">*</span>
                          </label>
                          <span className="p-float-label">
                            <Dropdown
                              id="yob"
                              name="yob"
                              // filter
                              filterBy="value"
                              value={formik.values.yob}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur("yob")}
                              options={dateOptions}
                              itemTemplate={numbersTemplate}
                              filter
                              className={classNames({
                                "p-invalid": isFormFieldValid("yob"),
                              })}
                            />
                          </span>
                          {getFormErrorMessage("yob")}
                        </div>
                      </div>
                      {isHijri && (
                        <>
                          <div className="col-md-3">
                            <div className="field mb-3">
                              <label htmlFor="monthOfBirth">
                                {i18n.t("MONTH_OF_BIRTH")}{" "}
                                <span className="tawun_red">*</span>
                              </label>
                              <span className="p-float-label">
                                <Dropdown
                                  id="mob"
                                  name="mob"
                                  // filter
                                  filterBy="value"
                                  value={formik.values.mob}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur("mob")}
                                  options={dateMonthOptions}
                                  itemTemplate={numbersTemplate}
                                  filter
                                  className={classNames({
                                    "p-invalid": isFormFieldValid("mob"),
                                  })}
                                />
                              </span>
                              {getFormErrorMessage("mob")}
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="field mb-3">
                              <label htmlFor="dayOfBirth">
                                {i18n.t("DAY_OF_BIRTH")}{" "}
                                <span className="tawun_red">*</span>
                              </label>
                              <span className="p-float-label">
                                <Dropdown
                                  id="dob"
                                  name="dob"
                                  // filter
                                  filterBy="value"
                                  value={formik.values.dob}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur("dob")}
                                  options={globalUtils.hijriDays}
                                  itemTemplate={numbersTemplate}
                                  filter
                                  className={classNames({
                                    "p-invalid": isFormFieldValid("dob"),
                                  })}
                                />
                              </span>
                              {getFormErrorMessage("dob")}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <OtpShared
        show={showOtp}
        lob={lob}
        userDetails={userDetails}
        handleOnVerifyOTPClicked={onOTPVerify}
        cancelOTP={() => setShowOtp(false)}
      />

      <div className="fit">
        <SubFooter
          priceDetails={null}
          nextBtnLabel={i18n.t("NEXT")}
          nextBtnHandler={formik.handleSubmit}
          nextBtnLoading={loading}
          hidePriceSection={true}
        />
      </div>

      <Popup
        visible={ctaVisible}
        text={ctaText}
        link={ctaLink}
        onClick={handleCTAClick}
        onMaskClick={() => setctaVisible(false)}
        autoRedirect={autoRedirect}
        onHide={() => setctaVisible(false)}
      />
    </LoginWrapper>
  );
};

export default withTranslation()(LoginNew);
